import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { Injectable, inject } from '@angular/core';
import { SharedModuleConfig } from './config/shared-module-config';

@Injectable({ providedIn: 'root' })
export class ApplicationInsightsLoggingService {
  private sharedModuleConfig = inject(SharedModuleConfig);

  appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: this.sharedModuleConfig.appInsights.instrumentationKey,
      enableAutoRouteTracking: true, // option to log all route changes
    },
  });

  constructor() {
    this.appInsights.loadAppInsights();
  }

  logPageView(name?: string, url?: string) {
    // option to call manually
    this.appInsights.trackPageView({
      name: name,
      uri: url,
    });
  }
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  logEvent(name: string, properties?: { [key: string]: any }) {
    this.appInsights.trackEvent({ name: name }, properties);
  }
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    this.appInsights.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights.trackException({
      exception: exception,
      severityLevel: severityLevel,
    });
  }
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  logTrace(message: string, properties?: { [key: string]: any }) {
    this.appInsights.trackTrace({ message: message }, properties);
  }
}
